import { createFileRoute, redirect } from '@tanstack/react-router'

import { DIALOG_PATHS } from '~/lib/dialogs'

/**
 * The address settings' data section wears while it is open. It is a mask over the page underneath, which is
 * where the router actually is — see `specs/tech.spec.md`. This route is what catches the
 * address arriving on its own: a link somebody shared, a bookmark, a reload with the masked
 * state gone. There is no page underneath to open over then, so it opens over the timeline,
 * and keeps the address it was asked for.
 */
export const Route = createFileRoute('/settings_/data')({
  beforeLoad: () => {
    redirect({
      to: '/',
      search: { dialog: 'data' },
      throw: true,
      mask: { to: DIALOG_PATHS.data },
    })
  },
})
